var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Chip, Stack } from '@mui/material';
import { IconButton } from '../../utils/IconButton';
import { DeleteIcon, EditIcon } from '../../utils/Icons';
import { Modal } from '../../utils/Modal';
import { FormikGenerator, TYPES } from '../../utils/FormikGenerator';
import { TypeSchema } from '../../utils/ValidationSchema';
import * as ServiceAdministration from '../../services/administration';
import { Table } from '../../utils/Table';
import { ConfirmDialog } from '../../utils/ConfirmDialog';
export var TypeListe = function (_a) {
    var types = _a.types, model = _a.model, handleRefresh = _a.handleRefresh, _b = _a.title, title = _b === void 0 ? null : _b;
    var handleDelete = function (_a) {
        var IdType = _a.IdType;
        return __awaiter(void 0, void 0, void 0, function () {
            var confirmation;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ConfirmDialog({
                            title: 'Suppression',
                            content: 'Êtes-vous sûr de vouloir supprimer ce type ?',
                            color: 'error',
                        })];
                    case 1:
                        confirmation = _b.sent();
                        if (!confirmation.isOk) return [3 /*break*/, 3];
                        return [4 /*yield*/, ServiceAdministration.deleteAdministration('Type', IdType)];
                    case 2:
                        _b.sent();
                        handleRefresh();
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return (_jsx(Table, { title: title, canEdit: true, headers: [
            {
                assessor: 'Libelle',
            },
            {
                minWidth: true,
                component: function (value) { return (_jsx(Chip, { color: value.Actif ? 'success' : 'error', label: value.Actif ? 'Actif' : 'Désactivé' })); },
            },
            {
                minWidth: true,
                component: function (value, _a) {
                    var handleUpdate = _a.handleUpdate;
                    return (_jsxs(Stack, __assign({ direction: "row", spacing: 1 }, { children: [_jsx(IconButton, __assign({ color: "primary", tooltip: "Modifier", onClick: function () { return handleUpdate(value); } }, { children: _jsx(EditIcon, {}) })), _jsx(IconButton, __assign({ color: "error", tooltip: "Supprimer", onClick: function () { return handleDelete(value); } }, { children: _jsx(DeleteIcon, {}) }))] })));
                },
            },
        ], datas: types ? types : [], renderModalEdition: function (handleClose, typeSelected) {
            return (_jsx(Modal, __assign({ handleCloseModal: handleClose, forceOpen: true, title: "Type \"".concat(model, "\"") }, { children: _jsx(FormikGenerator, { submitLabel: typeSelected.IdType ? 'Enregistrer' : 'Ajouter', datas: __assign(__assign({}, typeSelected), { Actif: typeSelected.Actif === undefined ? true : typeSelected.Actif }), validationSchema: TypeSchema, onSubmit: function (_a) {
                        var Actif = _a.Actif, Libelle = _a.Libelle;
                        return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0: return [4 /*yield*/, ServiceAdministration.postAdministration('Type', __assign(__assign({}, typeSelected), { Model: model, Actif: Actif, Libelle: Libelle }))];
                                    case 1:
                                        _b.sent();
                                        handleRefresh();
                                        handleClose();
                                        return [2 /*return*/];
                                }
                            });
                        });
                    }, fields: [
                        [
                            {
                                name: 'Actif',
                                label: 'Actif',
                                type: TYPES.BOOLEAN,
                            },
                            {
                                name: 'Libelle',
                                label: 'Libelle',
                                type: TYPES.TEXT,
                                uppercaseFirstChar: true,
                            },
                        ],
                    ] }) })));
        } }));
};
//# sourceMappingURL=TypeListe.js.map